import {Directive, EventEmitter, inject, OnInit, Output, ViewContainerRef} from '@angular/core';

@Directive({
    selector: '[appTableCellOnload]'
})
export class TableCellDirective implements OnInit {

  @Output() loadCell: EventEmitter<ViewContainerRef> = new EventEmitter<ViewContainerRef>();

  private readonly viewContainerRef = inject(ViewContainerRef);

  ngOnInit(): void {
    this.loadCell.emit(this.viewContainerRef);
  }

}
